import React from 'react';
import { Box } from '@wix/design-system';
export const ShowcaseSingleCard = ({ children, className, dataHook, ...boxPropsOverrides }) => {
    return (React.createElement(Box, { className: className, dataHook: dataHook, borderRadius: "6px", direction: "vertical", verticalAlign: "middle", align: "center", gap: "12px", ...boxPropsOverrides }, children));
};
//# sourceMappingURL=ShowCaseSingleCard.js.map